import { render, staticRenderFns } from "./ChatInterface.vue?vue&type=template&id=056ade32&scoped=true"
import script from "./ChatInterface.vue?vue&type=script&lang=js"
export * from "./ChatInterface.vue?vue&type=script&lang=js"
import style0 from "./ChatInterface.vue?vue&type=style&index=0&id=056ade32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ade32",
  null
  
)

export default component.exports